export default function MissionSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Our Mission
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              To advance the health and wellbeing of Canadians and their animal companions by fostering collaboration between pharmacists and veterinarians, promoting excellence in practice, and advocating for integrated healthcare solutions.
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6">
              <h3 className="text-xl font-semibold text-blue-900 mb-3">Our Vision</h3>
              <p className="text-blue-800">
                A Canada where human and animal health are seamlessly integrated, supported by collaborative healthcare professionals who work together to create healthier communities for all.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-green-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Professional Excellence</h4>
                  <p className="text-sm text-gray-600">Advancing standards in both pharmacy and veterinary practice</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-team-line text-blue-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Collaborative Care</h4>
                  <p className="text-sm text-gray-600">Bridging disciplines for comprehensive health solutions</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/f1b3c0a92e645c4d75cd2262bf33a3b8.jpg"
              alt="Healthcare professionals collaborating"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}